module.exports = __webpack_public_path__ + "static/media/metoffice.6a1a7b92.png";